import React from 'react';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import {
  Grid,
  withStyles,
  Typography,
  Button,
  FormControl,
  Menu,
  MenuItem,
  ListItemText,
  TextField,
} from '@material-ui/core';
import config from '../../../../config';
import '../style.css';

class HeaderBar extends React.Component {
  render() {
    const {
      classes,
      t,
      seeFunc,
      styleFullScreen,
      subgroupAll,
      groupsList,
      group,
      subList,
      module,
      routerNoSignal,
      router,
      page,
      gridPage,
      searchHN,
      sort,
      anchorEl,
    } = this.props;
    return (
      <div style={styleFullScreen} className={classes.wrap}>
        <Grid container>
          {/* <Grid container item md={8} xs={8}>
            <Typography className={classes.fontHeader}>
              {t("all_patients")}
            </Typography>
            <Typography className={classes.fontText}>
              Last System active 12:30 23/04/21
            </Typography>
            <Typography className={classes.fontLink}>Refresh</Typography>
          </Grid>
          <Grid container item md={4} xs={4} className={classes.wrapbtnAdd}>
            <Button
              variant="contained"
              color="primary"
              className={classes.btnAdd}
            >
              Add patient
            </Button>
          </Grid> */}

          <Grid container item lg={10} md={10} sm={12} xs={12}>
            {seeFunc.seeOrganization && (
              <Grid container item xs={3} sm={3} md={3}>
                <FormControl className={classes.formControl}>
                  <TextField
                    variant='outlined'
                    select
                    size='small'
                    value={group || ''}
                    name='group'
                    id='group'
                    className={classes.contentSelect}
                    // InputLabelProps={{
                    //   className: classes.formLabel,
                    // }}
                    // InputProps={{
                    //   className: !group ? classes.inputColor : ''
                    // }}
                    onChange={(e) => {
                      this.props.handleChange(e);
                    }}
                    SelectProps={{
                      native: true,
                      IconComponent: () => (
                        <div className={classes.iconSelect}>
                          <svg width='15' height='8' viewBox='0 0 15 8'>
                            <use xlinkHref={`/images/toolbar.svg#dropdown`} />
                          </svg>
                        </div>
                      ),
                    }}
                    // label={config.configType ? t("organization") : t("group")}
                    disabled={groupsList.length === 1 ? true : false}
                  >
                    <option value='' disabled>
                      {config.configType ? t('select_organization') : t('select_group')}
                    </option>
                    {(groupsList || []).map((val) => (
                      <option value={val.id} key={`group-${val.id}`}>{`${val.name || ' - '}`}</option>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>
            )}
            {seeFunc.seeGroup && (
              <Grid container item xs={3} sm={3} md={3}>
                <FormControl variant='outlined' className={classes.formControl} fullWidth>
                  <TextField
                    variant='outlined'
                    select
                    size='small'
                    value={module || ''}
                    name='module'
                    id='module'
                    className={classes.contentSelect}
                    // InputLabelProps={{
                    //   className: classes.formLabel,
                    // }}
                    // InputProps={{
                    //   className: !module ? classes.inputColor : ''
                    // }}
                    onChange={(e) => {
                      this.props.handleChange(e);
                    }}
                    SelectProps={{
                      native: true,
                      IconComponent: () => (
                        <div className={classes.iconSelect}>
                          <svg width='15' height='8' viewBox='0 0 15 8'>
                            <use xlinkHref={`/images/toolbar.svg#dropdown`} />
                          </svg>
                        </div>
                      ),
                    }}
                    // label={config.configType ? t("group") : t("module")}
                  >
                    <option value='' disabled>
                      {config.configType ? t('select_group') : t('select_module')}
                    </option>
                    {subList.length > 1 && <option value={subgroupAll}>{t('all')}</option>}
                    {(subList || []).map((val) => (
                      <option
                        value={JSON.stringify([val.id])}
                        key={`module-${val.id}`}
                      >{`${val.name || ' - '}`}</option>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>
            )}
            {seeFunc.seeFilter && (
              <Grid container item xs={2} sm={2} md={2}>
                <FormControl variant='outlined' className={classes.formControl} fullWidth>
                  <TextField
                    variant='outlined'
                    size='small'
                    value={searchHN}
                    name='searchHN'
                    id='searchHN'
                    className={classes.contentInput}
                    placeholder={t('search')}
                    onChange={(e) => this.props.handleChangeSearch(e)}
                  ></TextField>
                </FormControl>
              </Grid>
            )}
            {seeFunc.seeSort && (
              <Grid container item xs={2} sm={2} md={2}>
                <FormControl className={classes.formControl}>
                  <TextField
                    variant='outlined'
                    select
                    size='small'
                    value={sort || ''}
                    name='sort'
                    id='sort'
                    className={classes.contentSelect}
                    // InputProps={{
                    //   className: !sort ? classes.inputColor : ''
                    // }}
                    // label={t("sort_room")}
                    // InputLabelProps={{
                    //   className: classes.formLabel,
                    // }}
                    onChange={(e) => {
                      this.props.handleChangeSort(e);
                    }}
                    SelectProps={{
                      native: true,
                      IconComponent: () => (
                        <div className={classes.iconSelect}>
                          <svg width='15' height='8' viewBox='0 0 15 8'>
                            <use xlinkHref={`/images/toolbar.svg#dropdown`} />
                          </svg>
                        </div>
                      ),
                    }}
                  >
                    <option value='' disabled>
                      {t('sort_room')}
                    </option>
                    <option value='showAll'>{t('show_all')}</option>
                    <option value='admitted'>{t('admitted')}</option>
                    <option value='priority-new'>{t('priority-new')}</option>
                    <option value='priority-old'>{t('priority-old')}</option>
                  </TextField>
                </FormControl>
              </Grid>
            )}
            {seeFunc.seeMap && (
              <Grid container item xs={2} sm={2} className={classes.wrapbtn}>
                <Button
                  id='map'
                  variant='outlined'
                  className={page === 2 ? classes.btnOutlinedActive : classes.btnOutlined}
                  onClick={this.props.handleChangePage.bind(this, 2)}
                >
                  <svg width='24' height='24' viewBox='0 0 22 22'>
                    <use xlinkHref={`/images/toolbar.svg#map`} />
                  </svg>
                  {localStorage.getItem('subgroup_type') === 'hospital' && (
                    <label
                      className='badge badge-error-map'
                      style={{
                        display: routerNoSignal.length === 0 ? 'none' : '',
                      }}
                    >
                      {routerNoSignal.length}/{router.routerInMaps.length}
                    </label>
                  )}
                  {t('map')}
                </Button>
              </Grid>
            )}
          </Grid>
          <Grid container item md={2} sm={4} xs={4} spacing={8} alignItems='center'>
            {seeFunc.seeGrid && (
              <Grid container item sm={6} xs={4} className={`${classes.wrapbtn} ${classes.btnmarTop}`}>
                <Button
                  fullWidth
                  variant='outlined'
                  id='grid-menu-mobile'
                  className={page === 0 ? classes.btnMobileActive : classes.btnMobile}
                  onClick={this.props.handleClickMobile}
                >
                  <svg width='18' height='18' viewBox='0 0 18 18'>
                    <use xlinkHref={`/images/toolbar.svg#gridview`} />
                  </svg>
                  <div style={{ marginLeft: 5 }}>{t('grid')}</div>
                </Button>

                <Button
                  fullWidth
                  variant='outlined'
                  id='grid-menu'
                  className={
                    page === 0
                      ? classNames(classes.btnPillActive, classes.btnPillDisplay)
                      : classNames(classes.btnPill, classes.btnPillDisplay)
                  }
                  onClick={this.props.handleClick}
                >
                  <svg width='18' height='18' viewBox='0 0 18 18'>
                    <use xlinkHref={`/images/toolbar.svg#gridview`} />
                  </svg>
                  <div style={{ marginLeft: 5 }}>{t('grid')}</div>
                </Button>
                <Menu
                  id='grid-menu'
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={this.props.handleClose}
                  className={classes.gridMenu}
                >
                  <MenuItem selected={gridPage === 3} onClick={() => this.props.handleChangeGrid('4')}>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>4 {t('boxs')}</Typography>
                        </React.Fragment>
                      }
                    />
                  </MenuItem>

                  <MenuItem selected={gridPage === 2} onClick={() => this.props.handleChangeGrid('6')}>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography>6 {t('boxs')}</Typography>
                        </React.Fragment>
                      }
                    />
                  </MenuItem>
                </Menu>
              </Grid>
            )}
            {seeFunc.seeList && (
              <Grid container item sm={6} xs={4} className={`${classes.wrapbtn} ${classes.btnmarTop}`}>
                <Button
                  id='listview'
                  fullWidth
                  variant='outlined'
                  className={page === 1 ? classes.btnPillActive : classes.btnPill}
                  onClick={this.props.handleClickList}
                >
                  <svg width='22' height='18' viewBox='0 0 22 18'>
                    <use xlinkHref={`/images/toolbar.svg#listview`} />
                  </svg>
                  <div style={{ marginLeft: 5 }}>{t('table')}</div>
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

const styles = (theme) => ({
  wrap: {
    width: '100%',
    // marginBottom: 20,
    padding: '10px !important',
    background: 'white',
    paddingRight: theme.spacing.unit * 1,
    paddingLeft: theme.spacing.unit * 1,
    boxShadow: '0px 0px 0px 0px rgba(0,0,0,0), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0)',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
  },
  formLabel: {
    color: theme.palette.text.primary,
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  contentSelect: {
    display: 'flex',
    '& fieldset': {
      top: '2px',
    },
    '& svg': {
      top: 'calc(58% - 8px)',
    },
    '& select': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  inputColor: {
    color: theme.palette.text.hint,
  },
  iconSelect: {
    position: 'absolute',
    backgroundColor: 'transparent !important',
    display: 'flex',
    marginBottom: '10px',
    top: 'calc(58% - 3px)',
    right: '4%',
    // right: "calc(10% - 18px)",
  },
  menu: {
    width: '300px',
  },
  fontHeader: {
    color: theme.palette.text.header,
    fontWeight: 'bold',
    fontSize: 38,
    padding: '0px 10px 0 5px',
  },
  fontText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.text.secondary,
    fontWeight: 500,
    padding: 10,
    marginTop: 10,
  },
  fontLink: {
    color: '#4CB6AC',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'underline',
    padding: 10,
    marginTop: 10,
  },
  wrapbtnAdd: {
    padding: 10,
    display: 'flex',
    justifyContent: 'end',
  },
  btnAdd: {
    width: 165,
    height: 40,
  },
  wrapbtn: {
    display: 'flex',
  },
  btnmarTop: {
    marginTop: 10,
    justifyContent: 'right',
  },
  // wrapbtnMap: {
  //   display: "flex",
  //   alignItems: "center",
  // },
  btnOutlined: {
    height: '38px',
    // width: 122,
    width: '70%',
    marginLeft: 4,
    top: '11px',
    fill: '#00978F',
    stroke: '#00978F',
    '&:hover': {
      backgroundColor: theme.palette.background.green,
      color: 'white',
      fill: 'white',
      stroke: 'white',
    },
  },
  btnOutlinedActive: {
    height: '38px',
    // width: 122,
    width: '70%',
    marginLeft: 4,
    top: '11px',
    backgroundColor: theme.palette.background.green,
    color: 'white',
    fill: 'white',
    stroke: 'white',
    '&:hover': {
      backgroundColor: theme.palette.background.green,
      color: 'white',
      fill: 'white',
      stroke: 'white',
    },
  },
  btnPillDisplay: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    [theme.breakpoints.up('xl')]: {
      marginRight: '-35px',
    },
  },
  btnPill: {
    height: '30px',
    width: 112,
    border: 'none',
    borderRadius: '20px',
    color: theme.palette.text.primary,
    fill: '#00978F',
    stroke: '#00978F',
    '&:hover': {
      borderRadius: '20px',
      backgroundColor: theme.palette.background.green,
      color: 'white',
      fill: 'white',
      stroke: 'white',
    },
  },
  btnPillActive: {
    height: '30px',
    width: 112,
    border: 'none',
    borderRadius: '20px',
    backgroundColor: theme.palette.background.green,
    color: 'white',
    fill: 'white',
    stroke: 'white',
    '&:hover': {
      borderRadius: '20px',
      backgroundColor: theme.palette.background.green,
      color: 'white',
      fill: 'white',
      stroke: 'white',
    },
  },
  btnMobile: {
    height: '30px',
    width: 112,
    border: 'none',
    borderRadius: '20px',
    color: theme.palette.text.primary,
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
    '&:hover': {
      backgroundColor: theme.palette.background.green,
      color: 'white',
      fill: 'white',
      stroke: 'white',
    },
  },
  btnMobileActive: {
    height: '30px',
    width: 112,
    border: 'none',
    borderRadius: '20px',
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
    backgroundColor: theme.palette.background.green,
    color: 'white',
    fill: 'white',
    stroke: 'white',
    '&:hover': {
      backgroundColor: theme.palette.background.green,
      color: 'white',
      fill: 'white',
      stroke: 'white',
    },
  },
  gridMenu: {
    marginTop: theme.spacing.unit * 7,
  },
  iconColor: {
    color: theme.palette.success.main,
  },
});

export const translation = withTranslation()(HeaderBar);
export default withStyles(styles, { withTheme: true })(translation);
